"use client";

import dynamic from 'next/dynamic';

const ContactForm = dynamic(
  () => import('@/components/ContactForm/ContactForm').then((mod) => mod.default),
  {
    ssr: false,
    loading: () => <p>Loading contact form...</p>, // Added loading fallback
  }
);

interface ContactFormClientWrapperProps {
  className?: string;
}

export default function ContactFormClientWrapper({ className }: ContactFormClientWrapperProps) {
  return <ContactForm className={className} />;
}
